// extracted by mini-css-extract-plugin
export var AdImage = "SportsCarousel-module--AdImage--279ef";
export var AdSec = "SportsCarousel-module--AdSec--6367d";
export var Aditems = "SportsCarousel-module--Aditems--3f1ea";
export var imagesSec = "SportsCarousel-module--imagesSec--66305";
export var items = "SportsCarousel-module--items--e4db0";
export var mt25 = "SportsCarousel-module--mt25--21ada";
export var seeall = "SportsCarousel-module--seeall--e204b";
export var sportsSec = "SportsCarousel-module--sportsSec--a6636";
export var todayblockimage = "SportsCarousel-module--todayblockimage--e087d";